import React, { Component } from "react";
import PropTypes from "prop-types";
import { IconContext } from "react-icons";
import { FaArrowCircleLeft, FaArrowCircleRight, FaTimes } from "react-icons/fa";
import { Link } from "gatsby";
import Img from "gatsby-image";
import Button from "../../Button/index.jsx";
import styles from "./style.module.scss";

class CustomizeGarment extends Component {
  state = {
    height: 0
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("keydown", this.onKeyPressed);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener("keydown", this.onKeyPressed);
  }

  updateWindowDimensions = () => {
    this.setState({ height: window.innerHeight });
  };

  onKeyPressed = e => {
    const { showPrev, showNext } = this.props;
    if (e.key === "ArrowLeft" && showPrev) {
      this.props.prevGarment();
    }
    if (e.key === "ArrowRight" && showNext) {
      this.props.nextGarment();
    }

    if (e.key === "Escape") {
      this.props.onClick();
    }
  };

  onSubmit = () => {
    this.setState({ submitted: true });
  };

  render() {
    const { garment, showPrev, showNext } = this.props;
    const { height } = this.state;

    const contactForm = () => (
      <div className={styles.inner}>
        <div className={styles.garmentDetails}>
          <h1>{garment.name}</h1>
          <h6>Garment Type // {garment.garmentType}</h6>
          <h6>Organization Name // {garment.organizationName}</h6>
          <h6>Organization Type // {garment.organizationType}</h6>
          <h3>
            Want this design or something like it? We will change anything and
            everything on this graphic for free so that you get custom apparel
            you love.
          </h3>
        </div>
        <Link to="/new-order" className={styles.link}>
          <Button
            secondary
            onClick={e => e.preventDefault}
            children="Customize garment"
          />
        </Link>
      </div>
    );

    return (
      <div style={{ minHeight: height }} className={styles.container}>
        <IconContext.Provider value={{ size: "2em", className: styles.toggle }}>
          <FaTimes onClick={this.props.onClick} />
        </IconContext.Provider>
        <div className={styles.inner}>
          <div className={styles.image}>
            <Img
              fluid={garment.image.fluid}
              title={garment.name}
              alt={garment.name}
            />
          </div>
          <div className={styles.pagination}>
            {showPrev ? (
              <IconContext.Provider value={{ size: "2em" }}>
                <FaArrowCircleLeft
                  onClick={this.props.prevGarment}
                  style={{ marginRight: "10px", cursor: "pointer" }}
                />
              </IconContext.Provider>
            ) : null}
            {showNext ? (
              <IconContext.Provider value={{ size: "2em" }}>
                <FaArrowCircleRight
                  onClick={this.props.nextGarment}
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                />
              </IconContext.Provider>
            ) : null}
          </div>
        </div>
        {contactForm()}
      </div>
    );
  }
}

CustomizeGarment.defaultProps = {
  showPrev: true,
  showNext: true
};

CustomizeGarment.propTypes = {
  garment: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  prevGarment: PropTypes.func.isRequired,
  nextGarment: PropTypes.func.isRequired,
  showPrev: PropTypes.bool,
  showNext: PropTypes.bool
};

export default CustomizeGarment;
